export type ChamberResetViewportKey =
  | 'Axial'
  | 'FourChamber'
  | 'TwoChamber'
  | 'ShortAxis';

const DEFAULT_SCOUT_DISPLAY_ROLL_CONFIG: Record<ChamberResetViewportKey, number> =
  {
    Axial: 0,
    FourChamber: 0,
    TwoChamber: 0,
    ShortAxis: 0,
  };

export function resetChamberScoutDisplayRollConfig(
  current: Partial<Record<ChamberResetViewportKey, number>> | undefined,
  viewportId: ChamberResetViewportKey,
): Record<ChamberResetViewportKey, number> {
  return {
    ...DEFAULT_SCOUT_DISPLAY_ROLL_CONFIG,
    ...current,
    [viewportId]: 0,
  };
}

export function resetChamberScoutDisplayRollProps<
  T extends { scoutDisplayRollRad?: number },
>(props: T): T & { scoutDisplayRollRad: 0 } {
  return {
    ...props,
    scoutDisplayRollRad: 0,
  };
}
